import {
  StatusFilterType,
  statusMessages,
} from '@app/modules/logger/screens/status/components/options';
import { segments } from '@mi-front/api-clients';
import { StatusBadge } from '@mi-front/ui';
import { Box, Chip, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useStatusQueryFilter } from '../../hooks/useStatusQueryFilter';

export function StatusActivityFilter({
  statuses,
  isLoading = false,
}: {
  statuses: segments.StationStatusDto[];
  isLoading?: boolean;
}) {
  const { queryParams, setQueryParams } = useStatusQueryFilter();

  const renderLabel = (value: StatusFilterType, count: number) => (
    <Box>
      <FormattedMessage {...statusMessages[value]} /> ({count})
    </Box>
  );

  // Pre-calculate counts to avoid repeated filtering
  const counts = {
    all: statuses.length,
    online: statuses.filter((s) => s.status === 'online').length,
    offline: statuses.filter((s) => s.status === 'offline').length,
  };

  // Common styles for filter buttons
  const commonButtonStyles = {
    // minWidth: '7rem',
    fontSize: '12px',
    cursor: 'pointer',
    textTransform: 'uppercase',
  } as const;

  // Helper to get button props for a filter type
  const getFilterButtonProps = (filterType: StatusFilterType) => {
    const isSelected = queryParams.status === filterType;
    return {
      variant: (isSelected ? 'filled' : 'outlined') as 'filled' | 'outlined',
      onClick: () => setQueryParams({ status: filterType }),
      sx: {
        ...commonButtonStyles,
        ...(isSelected && {
          fontWeight: 500,
        }),
      },
    };
  };

  return (
    <Stack direction="row" spacing={1}>
      <Chip
        label={renderLabel(StatusFilterType.ALL, counts.all)}
        clickable
        color="info"
        {...getFilterButtonProps(StatusFilterType.ALL)}
      />
      <StatusBadge
        status
        onText={renderLabel(StatusFilterType.ONLINE, counts.online)}
        {...getFilterButtonProps(StatusFilterType.ONLINE)}
      />
      <StatusBadge
        status={false}
        onText={renderLabel(StatusFilterType.OFFLINE, counts.offline)}
        {...getFilterButtonProps(StatusFilterType.OFFLINE)}
      />
    </Stack>
  );
}
